import { Box } from "@mui/material";

import { Option } from "api/common/types/common.types";
import { Scheme } from "api/public/schemes/schemes.types";
import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const SchemeSelectSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    schemes: [] as Scheme[],
  },
  render: function Render({ form, schemes }) {
    const schemeOptions: Option[] = schemes.map((scheme: Scheme) => ({
      label: scheme.cid__name,
      value: scheme.cid__code2_iso,
    }));

    return (
      <Box sx={{ mb: 4 }}>
        <form.AppField
          name="scheme"
          listeners={{
            onChange: () => {
              // Reset downstream fields when scheme changes
              // Data fetching is handled reactively by usePcmCascadingData
              form.resetField("ccProduct");
              form.resetField("ccLab");
              form.resetField("ccMaintenance");
            },
          }}
        >
          {(field) => (
            <field.AutocompleteSelect
              options={schemeOptions}
              label="Scheme"
              required
            />
          )}
        </form.AppField>
      </Box>
    );
  },
});

export default SchemeSelectSection;
